import { createIcon } from '../createIcon.tsx';

export const ChevronLeftIcon = createIcon('ChevronLeftIcon', <polyline points="15 18 9 12 15 6" />);
